import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, CardContent, Grid, TextField, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useTQuery } from '../../../../../utils/useTQuery';
// import { previousStep, update } from '../../../../../slice/multiStepSlice';
// import { nextStep } from '../../../../../slice/onBoardWizardSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';







// Define schema for form validation
export const roleSchema = z.object({
    ROLE_IDS: z.array(z.string()).min(1, { message: "At least one role must be selected" }),
});

const CreateChecklist = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    const [checkListname,setCheckListName] = useState("")
    const [roles, setRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);

    const { data: rolesData } = useTQuery(
        "jobs_roles",
        "/jobRoles",
        "post"
    );

    useEffect(() => {
        if (rolesData?.STATUS) {
            setRoles(rolesData.OUTPUT);
        }
    }, [rolesData]);
    useEffect(() => {
        if(values.ROLE_IDS) {
            console.log("cehek web",values)
            setSelectedRoles(values.ROLE_IDS);
if(values?.specialityChecklist){
    setCheckListName(values?.specialityChecklist[0]?.checklistName)
}
           

        }
        
    }, [values])
    const {
        control,
        handleSubmit,
        register,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: { ROLE_IDS: values.ROLE_IDS||[] ,
        },
    });

    const {mutateAsync} = useTMutation("/addUpdateSpecialty", "post", (response) => {
return response
    });

    const submitCreateChecklist = async (formData) => {
        try {
            const response = await mutateAsync({
                ...formData,
                ID: values?.ID
            });
        
            if (response.STATUS) {
                dispatch(update({ROLE_IDS:formData?.ROLE_IDS,checklistName:checkListname} ))
                
                dispatch(nextStep())
                showToast("success", response.MESSAGE, 3000);
                // navigate("/admin/profile-criteria/fetchSpecialtyRoleMappings")
            } else {
                showToast("error", response.MESSAGE, 3000);
            }
      
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (roleId) => {
        setSelectedRoles((prev) => prev.filter(id => id !== roleId));
        setValue('ROLE_IDS', selectedRoles.filter(id => id !== roleId));
        clearErrors('ROLE_IDS');
    };

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
            const updatedRoles = [...selectedRoles, selectedRoleId];
            setSelectedRoles(updatedRoles);
            setValue('ROLE_IDS', updatedRoles);
        }
    };
    console.log("asdasd" , roles , values)

    return (
        <>
                    {!values.REDIRECT && <Button
                                    onClick={() => dispatch(previousStep())}
                                    startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                                    sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
                                >
                                </Button>}
                         <Grid lg={12} p={4}> 

                         <CardContent>
                            <Typography variant="h2" component="div" mb={4} fontWeight="bold">
                              Create checklist
                            </Typography>
                            <form onSubmit={handleSubmit(submitCreateChecklist)}>
                               
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField
                                label="Checklist Name"
                                variant="outlined"
                                fullWidth
                                value={checkListname}
                                margin="normal"
                                autoFocus={true}
                                onChange={(e)=> setCheckListName(e.target.value)}
                                
                                // InputProps={{ style: { height: '50px' } }}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: 1.94
                                    },
                                    '& .MuiFormHelperText-root': {
                                        marginLeft: 0,
                                        marginTop: '4px',
                                    },
                                }}
                                // {...register("SPECIALTY_NAME")}
                                error={!!errors.SPECIALTY_NAME}
                                helperText={errors.SPECIALTY_NAME?.message}
                            />
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                <Button 
                                // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                className='gradientAdminThemeColor'
                                type='submit'>
                                    Next
                                </Button>
                            </Box>
                        </Box>
                            </form>
                        </CardContent> 

   </Grid> 
              
        </>
    );
};

export default memo(CreateChecklist);
